import React from 'react';
import styles from './ExtraToolbar.module.css';

// Secondary toolbar across the top of the canvas area.
// Measure / Annotate / Actions — all the tools that don't fit on the 44px left strip.
export default function ExtraToolbar({
  activeTool, onSelect, onAction,
  canCompare = true,
}) {
  const section = (title, items) => (
    <div className={styles.section}>
      <span className={styles.label}>{title}</span>
      {items.map(t => {
        const active = t.id === activeTool;
        return (
          <button key={t.id}
                  className={`${styles.tool} ${active ? styles.active : ''}`}
                  onClick={() => t.action ? onAction?.(t.id) : onSelect?.(t.id)}
                  title={t.hint}>
            {t.label}
          </button>
        );
      })}
    </div>
  );

  return (
    <div className={styles.bar}>
      {section('MEASURE', [
        { id: 'distance',    label: 'Dist',       hint: 'Distance (M)' },
        { id: 'angle',       label: 'Angle',      hint: 'Angle (A)' },
        { id: 'cobb',        label: 'Cobb',       hint: 'Cobb angle (Shift+C)' },
        { id: 'ellipse',     label: 'Ellipse',    hint: 'Region of interest' },
        { id: 'calibration', label: 'Calibrate',  hint: 'Set mm/px calibration' },
      ])}
      {section('ANNOTATE', [
        { id: 'arrow', label: 'Arrow',  hint: 'Arrow (N)' },
        { id: 'text',  label: 'Text',   hint: 'Text note (T)' },
        { id: 'rect',  label: 'Box',    hint: 'Rectangle' },
        { id: 'pin',   label: 'Pin',    hint: 'Pin (patient-reported landmark)' },
      ])}
      {section('ACTIONS', [
        { id: 'compare',   label: 'Compare',      hint: 'Prior-study comparison', action: true },
        { id: 'pdf',       label: 'PDF',          hint: 'Export signed PDF',       action: true },
        { id: 'zip',       label: 'Burn to disc', hint: 'Download study ZIP',      action: true },
        { id: 'shortcuts', label: '?',            hint: 'Keyboard shortcuts',      action: true },
      ])}
    </div>
  );
}
